import React, { useEffect, useState } from "react";

import AdminToolsDataService from "../../../services/admin-tools.service";
import { NotificationManager } from "react-notifications";
import { useTranslation } from "react-i18next";
import { Button, Input, Modal, Table, Tooltip } from "antd";

const LockedUsers = () => {
  const { t } = useTranslation();
  const { Search } = Input;
  const [loading, setLoading] = useState(false);
  const [lockedUsersList, setLockedUsersList] = useState([]);
  const [unlockingUserId, setUnlockingUserId] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);

  useEffect(() => {
    handleGetLockedUsers();
  }, []);

  const handleGetLockedUsers = () => {
    setLoading(true);
    AdminToolsDataService.GetLockedUsers()
      .then((response) => {
        setLoading(false);
        if (response.data.status && response.data.responseData) {
          setLockedUsersList(response.data.responseData);
        } else {
          setLockedUsersList([]);
        }
      })
      .catch((error) => {
        setLoading(false);
        setLockedUsersList([]);
        console.log(error);
      });
  };

  const handleUnlockUser = (row) => {
    setUnlockingUserId(row.userId);
    AdminToolsDataService.UnlockUser({ userId: row.userId })
      .then((response) => {
        setUnlockingUserId(null);
        setSelectedUser(null);
        if (response.data.status) {
          NotificationManager.success(t("User Unlocked Successfully."));
          handleGetLockedUsers();
        } else {
          NotificationManager.error(t("User Not Unlocked"));
        }
      })
      .catch((error) => {
        setUnlockingUserId(null);
        setSelectedUser(null);
        NotificationManager.error(t("User Not Unlocked"));
        console.log(error);
      });
  };

  const filteredData = searchText
    ? lockedUsersList.filter((x) => {
        const q = searchText.toLowerCase();
        return (
          (x.dealerID && x.dealerID.toString().toLowerCase().includes(q)) ||
          (x.dealerCompany && x.dealerCompany.toLowerCase().includes(q)) ||
          (x.email && x.email.toLowerCase().includes(q)) ||
          (x.userName && x.userName.toLowerCase().includes(q))
        );
      })
    : lockedUsersList;

  function handlePageNoChange(page, size) {
    var tableBody = document.querySelector(".lockedusers_tbldiv .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    setPageNo(page);
    setPageSize(size);
  }
  function handlePageSizeChange(current, size) {
    setPageNo(1);
    setPageSize(size);
  }

  const columnTitle = (title) => <Tooltip title={t(title)}>{t(title)}</Tooltip>;

  return (
    <React.Fragment>
      <div className="lockedusers_section">
        <div className="form__fields">
          <div className="row">
            <div className="col-lg-12">
              <div className="heading__block d-flex justify-content-between align-items-center flex-wrap" style={{ gap: "12px" }}>
                <h4 className="workarea__heading mt-0 mb-0">
                  {t("Locked Users")}
                </h4>
                <div className="search__bar" style={{ width: "220px" }}>
                  <Search
                    placeholder={t("Search")}
                    allowClear
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      setPageNo(1);
                    }}
                    onSearch={(value) => {
                      setSearchText(value);
                      setPageNo(1);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-12 mt-4">
              <div className="lockedusers_tbldiv">
                <Table
                  rowKey="userId"
                  scroll={{ x: 700, y: "calc(100vh - 340px)" }}
                  columns={[
                    {
                      title: columnTitle("Dealer ID"),
                      dataIndex: "dealerID",
                      width: 110,
                      sorter: (a, b) => (a.dealerID || 0) - (b.dealerID || 0),
                    },
                    {
                      title: columnTitle("Dealer Company"),
                      dataIndex: "dealerCompany",
                      ellipsis: true,
                      sorter: (a, b) =>
                        (a.dealerCompany || "").localeCompare(b.dealerCompany || ""),
                    },
                    {
                      title: columnTitle("Email"),
                      dataIndex: "email",
                      ellipsis: true,
                      sorter: (a, b) => (a.email || "").localeCompare(b.email || ""),
                    },
                    {
                      title: columnTitle("User Name"),
                      dataIndex: "userName",
                      ellipsis: true,
                      sorter: (a, b) =>
                        (a.userName || "").localeCompare(b.userName || ""),
                    },
                    {
                      title: columnTitle("Action"),
                      key: "action",
                      width: 120,
                      render: (item, row) => (
                        <Button
                          className="primary-btn"
                          onClick={() => setSelectedUser(row)}
                        >
                          {t("Unlock")}
                        </Button>
                      ),
                    },
                  ]}
                  pagination={{
                    size: "small",
                    total: filteredData.length,
                    current: pageNo,
                    pageSize: pageSize,
                    pageSizeOptions: [10, 15, 20, 50, 100],
                    responsive: true,
                    showSizeChanger: true,
                    onChange: handlePageNoChange,
                    onShowSizeChange: handlePageSizeChange,
                  }}
                  dataSource={filteredData}
                  loading={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        title={t("Unlock Confirmation")}
        centered
        visible={!!selectedUser}
        onCancel={() => setSelectedUser(null)}
        width={400}
        footer={[
          <Button
            key="back"
            className="ghost-btn"
            style={{ minWidth: 80 }}
            onClick={() => setSelectedUser(null)}
          >
            {t("Cancel")}
          </Button>,
          <Button
            key="submit"
            className="primary-btn"
            style={{ minWidth: 80 }}
            loading={!!selectedUser && unlockingUserId === selectedUser.userId}
            onClick={() => handleUnlockUser(selectedUser)}
          >
            {t("Unlock")}
          </Button>,
        ]}
      >
        <p>{t("Are you sure you want to unlock this user?")}</p>
        {selectedUser && (
          <p className="mb-0">
            <b>{selectedUser.userName}</b> ({selectedUser.email})
          </p>
        )}
      </Modal>
    </React.Fragment>
  );
};

export default LockedUsers;
